import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useCccAuth } from '../contexts/CccAuthContext';
import cccAuthApi from '../api/cccAuthApi';
import { hasStoredSession } from '../auth/sessionBridge';

/**
 * After login on CCC backend, hydrate user profile from /api/ccc/auth/me.
 * Skipped on /login — avoids side effects during login page render.
 */
const CccSessionBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { isAuthenticated, user, refreshUser } = useCccAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (pathname === '/login') return;
    if (!hasStoredSession() || ran.current) return;
    ran.current = true;

    void (async () => {
      try {
        if (!user) {
          await refreshUser();
        }
        const me = await cccAuthApi.getMe();
        if (me && typeof me === 'object') {
          try {
            const raw = JSON.stringify(me);
            localStorage.setItem('user', raw);
            localStorage.setItem('cognito_user', raw);
            if (me.tenant != null) localStorage.setItem('user_tenant', String(me.tenant));
          } catch {
            /* storage blocked */
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[CCC] session hydrate failed', e);
      }
    })();
  }, [pathname, isAuthenticated, user, refreshUser]);

  return <>{children}</>;
};

export default CccSessionBootstrap;
